import { VerifyEmailSuccess } from './VerifyEmailSuccess';
export default VerifyEmailSuccess;
